import { Moment } from "moment";
import Utils from "../utils";
import { SyncModel, SyncDataModel, DataModel } from "./syncModel";
import { InternationalisationService } from "../../forked/angular-internationalisation";

export class SettingsRegistrationViewModel {
  public id: number;
  public register_term_text_de: string;
  public register_term_text_en: string;
  public get register_term_text(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.register_term_text_en) ? this.register_term_text_de : this.register_term_text_en;
  }
  public newsletter_show_optin: boolean;
  public newsletter_text_de: string;
  public newsletter_text_en: string;
  public get newsletter_text(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.newsletter_text_en) ? this.newsletter_text_de : this.newsletter_text_en;
  }
  public google_client_id: string;
  public facebook_app_id: string;
  public thirdparty_login_enabled: boolean
}

export class SettingsRegistrationDataViewModel {
  public id: number;
  public register_welcome_text_de: string;
  public register_welcome_text_en: string;
  public get register_welcome_text(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.register_welcome_text_en) ? this.register_welcome_text_de : this.register_welcome_text_en;
  }
}
export class SettingsMainNavDataViewModel {
  public id: number;
  public language: string;
}

// Requests
export class SettingsSyncModel extends SyncModel {
}

// Responses

/** Only one settings exists and it has the id=0 (this const is used for selecting the settings) */
export const SettingsDMKey: number = 0;

export class SettingsDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; } // only SettingsDMKey
  public id: number; // only SettingsDMKey
  public register_term_text_de: string;
  public register_term_text_en: string;
  public register_welcome_text_de: string;
  public register_welcome_text_en: string;
  public newsletter_show_optin: boolean;
  public newsletter_text_de: string;
  public newsletter_text_en: string;
  public get newsletter_text(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.newsletter_text_en) ? this.newsletter_text_de : this.newsletter_text_en;
  }
  /** if EmptyString davice language and can be changed by user (see laungeChoice in communicationdata), else only "de" or "en" */
  public language: string;
  public change_at_ymd: number;
  public change_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
  public change_by: number;
  public google_client_id: string;
  public facebook_app_id: string;
  public thirdparty_login_enabled: boolean;
}

export class SettingsSyncDataModel extends SyncDataModel {
  public settings: SettingsDataModel[];
  public get models(): DataModel[] { return this.settings; }
  public DeserializeType(): void {
    this._DeserializeType(SettingsDataModel);
  }
}
